module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen.96b946b1.png";